import { useTranslation } from 'react-i18next';

import { QSpinner, QText } from '@qualio/ui-components';
import { EventTag } from '../../../types';
import TagItemLabel from './TagItemLabel';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

const ActiveTagFilter = ({ value, tagsMap }: { value: unknown; tagsMap: Record<string, EventTag> }) => {
  const { t } = useTranslation();
  if (value === EMPTY_FILTER_VALUE) {
    return <QText as="span">{t('common.labels.emptyTags')}</QText>;
  }
  const id = value as string;
  const tag = tagsMap[id];
  if (tag) {
    return <TagItemLabel tag={tag} />;
  }
  return <QSpinner size="sm" />;
};

export default ActiveTagFilter;
